import { useEffect, useState } from "react";

import { Button } from "@needl-ai/common/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@needl-ai/common/components/ui/dialog";

const DISCLAIMER_STORAGE_KEY = "research_assist_disclaimer_shown";

const ICRAResearchAssistDisclaimer = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasSeenDisclaimer = localStorage.getItem(DISCLAIMER_STORAGE_KEY);
    if (!hasSeenDisclaimer) {
      setIsOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(DISCLAIMER_STORAGE_KEY, "true");
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent
        className="max-w-2xl"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-center">
            Accept Terms and Condition
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 text-sm text-gray-700 dark:text-gray-300">
          <div>
            <span className="font-semibold">1. Accuracy and Completeness:</span>{" "}
            The answers generated by our Gen-AI based RAG utility are not 100%
            accurate or comprehensive. The utility synthesizes information from
            various sources, and while it aims to provide useful insights, it
            may not capture all nuances or details. Users are strongly
            encouraged to refer to the original documents for a complete and
            accurate understanding of the information.
          </div>

          <div>
            <span className="font-semibold">
              2. Reference to Original Documents:
            </span>{" "}
            The answers provided by the RAG utility are indicative and intended
            for informational purposes only. They do not substitute for a
            thorough review of the underlying research documents. Users are
            strongly encouraged to refer to the original documents for a
            complete and accurate understanding of the information.
          </div>

          <div>
            <span className="font-semibold">3. No Liability:</span> ICRA assumes
            no responsibility for any errors or omissions in the information
            provided by the RAG utility. Users should not rely on the
            information/answers generated by our Gen.AI-based RAG utility for
            arriving at any conclusion or decision, ICRA shall not be liable for
            any losses or damages arising from the use of the RAG utility.
          </div>
        </div>

        <div className="flex justify-center pt-2">
          <Button
            onClick={handleAccept}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2 transition-colors"
          >
            Accept
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ICRAResearchAssistDisclaimer;
